import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/app/components/Navbar/NavBarHubContainer.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/next/dist/client/legacy/image.js");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/next/dist/client/link.js");
